<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div id="app_version">Version {{app_version}}</div>
    <div class="auth-inner py-2">

      <!-- Login v1 -->
         <b-overlay
          :show="loading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
          variant="white"
          opacity="0.95"
          blur="1rem"
        >
        <template #overlay><img src="//cloudfit.pro/cloudmedia-logo-loading.gif" style="max-width:85px;max-height:85px;"/></template>
      <b-card class="mb-0">
    
        <b-link class="brand-logo">


          <img src="//cloudfit.pro/cloudmedia-logo-animation.gif" v-if="domain == 'www.cloudfit.pro' || domain == '192.168.1.253:9090'" style="max-width:85px">
          <img src="//cloudfit.pro/static/valleyFIT_logo.jpg" v-if="domain == 'valleyfit.gfs.hk' || domain == 'valleyfitstudio.gfs.hk'" style="max-width:70%">
        </b-link>

        <b-card-title class="mb-1">
          Welcome to CloudFit Pro! 
        </b-card-title>
        <b-card-text class="mb-2">
          Please sign-in to your account and start the adventure
        </b-card-text>
        <!-- form -->
        <validation-observer
          ref="loginForm"
          #default="{invalid}"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent
          >

            <!-- email -->
            <b-form-group
              label-for="username"
              label="Username"
            >
              <validation-provider
                #default="{ errors }"
                name="Username"
                rules="required"
              >
                <b-form-input
                  id="username"
                  v-model="username"
                  name="login-username"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Username"
                  autofocus
                  autocomplete="off"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- password -->
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="password">Password</label>
                <!--<b-link :to="{name:'auth-forgot-password-v1'}">
                  <small>Forgot Password?</small>
                </b-link>-->
              </div>
              <validation-provider
                #default="{ errors }"
                name="Password"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid':null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false:null"
                    name="login-password"
                    placeholder="Password"
                    autocomplete="off"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- submit button -->
            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid"
              @click="login"
            >
              Sign in
            </b-button>
          </b-form>
        </validation-observer>
        
       
        <!-- <div class="divider my-2">
          <div class="divider-text">
            or
          </div>
        </div>

       
        <b-card-text class="text-center mt-2">
          <span>New on CloudFit? </span>
          <b-link
            :to="{name:'account-register'}"
            class="signup-typewriter signup-typewriter--block py-1"
            aria-label="Create an account"
          >
            <span class="signup-typewriter__text-idle">Create</span>
            <span class="signup-typewriter__text-done">Sign up</span>
            <span class="signup-typewriter__cursor" aria-hidden="true" />
          </b-link>
        </b-card-text> -->

      
       
      </b-card>
        </b-overlay>
      <!-- /Login v1 -->
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BOverlay,BButton, BForm, BFormInput, BFormGroup, BCard, BLink, BCardTitle, BCardText, BInputGroup, BInputGroupAppend, BFormCheckbox,
} from 'bootstrap-vue'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import { v4 as uuidv4 } from 'uuid'


export default {
  components: {
    // BSV
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BOverlay,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      loading: false,
      app_version : '',
      username: '',
      client:'',
      password: '',
      status: '',
      domain : 'www.cloudfit.pro',
      // validation rules
      required,
      email,
    }
  },
  created () {
    this.test2()
    localStorage.setItem('reader_action', 'staff_check_in')
    this.app_version = process.env.VUE_APP_VERSION
    // console.log(process.env.VUE_APP_VERSION)
    // console.log(this.app_version)
    const host = window.location.host
    this.domain = host
    this.client = host.split(".")

  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
  },
  methods: {
   
    login() {
      const socket_id = localStorage.getItem('socket_id')
      this.$http.defaults.headers.Version = this.app_version
      this.loading = true
      this.$http.post(process.env.VUE_APP_API_BASE+'/auth/', {
        username: this.username,
        password: this.password,
        socket_id: socket_id,
        version: this.app_version
      })
        .then(res => {
          if (res.data.result === true) {
            const userData = res.data
            this.$store.commit('center/UPDATE_CENTER_ID', userData.default_center_id)
            this.$store.commit('center/UPDATE_CENTER_NAME', userData.default_center_name)
            
            localStorage.setItem('whatsapp_id', userData.whatsapp_id)
            window.dispatchEvent(new Event('whatsapp-ready'))
            
            this.$http.defaults.headers.Token = res.data.token
            this.$i18n.locale = userData.language
            this.$socket.io.opts.query = { socket_id }
            this.$socket.connect()
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: `Welcome ${userData.fullName}`,
                icon: 'CoffeeIcon',
                variant: 'success',
                text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
              },
            })

            localStorage.setItem('userData', JSON.stringify(userData))
            this.$ability.update(userData.ability)
            localStorage.setItem('reader_action', 'normal')
            this.$router.replace(userData.landing_url).then(() => {})
         //   console.log(userData.ability)
          } else {
            this.loading = false
            this.$toast({
              component: ToastificationContent,
              position: 'top-center',
              props: {
                title: 'Error',
                icon: 'XIcon',
                variant: 'danger',
                text: res.data.message,
              },
            })
          }
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
#app_version {
  position:fixed;
  bottom:10px;
  right:10px;
  color:#aaa;
  font-weight:bold;
}

.signup-typewriter {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 7rem;
  margin-left: 0.35rem;
  padding: 0.65rem 1rem;
  color: #eceaf5;
  font-family: 'Poppins', monospace;
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1;
  border-radius: 0.6rem;
  isolation: isolate;
  overflow: visible;
  -webkit-tap-highlight-color: transparent;

  &:hover,
  &:focus,
  &:focus-visible {
    color: #eceaf5;
    text-decoration: none;
  }

  &:focus-visible {
    outline: 2px solid #00d4aa;
    outline-offset: 2px;
  }

  &::before {
    content: '';
    position: absolute;
    inset: -3px;
    z-index: -2;
    border-radius: calc(0.6rem + 3px);
    background: linear-gradient(135deg, #7367f0, #00d4aa);
    clip-path: polygon(0% 100%, 0% 100%, 0% 100%, 0% 100%, 0% 100%);
    transition: clip-path 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: -1;
    border: 1px solid #d8d6de;
    border-radius: 0.6rem;
    background: #fff;
    transition: border-color 0.3s ease;
  }

  &:hover::before,
  &:focus-visible::before {
    clip-path: polygon(0% 100%, 0% 0%, 100% 0%, 100% 100%, 0% 100%);
  }

  &:hover::after,
  &:focus-visible::after {
    border-color: transparent;
    transition: border-color 0.2s ease 0.2s;
  }

  &:active {
    transform: scale(0.97);
  }
}

.signup-typewriter--block {
  display: flex;
  width: 100%;
  margin: 0.75rem 0 0;
}

.signup-typewriter__text-idle,
.signup-typewriter__text-done {
  display: inline-block;
  overflow: hidden;
  max-width: 5em;
  color: #5e5873;
  font-size: 0.78rem;
  font-weight: 600;
  white-space: nowrap;
  direction: ltr;
}

.signup-typewriter__text-idle {
  transition: max-width 0.35s steps(7, end) 0.3s;
}

.signup-typewriter__text-done {
  max-width: 0;
  transition: max-width 0.25s steps(7, end);
}

.signup-typewriter__cursor {
  display: inline-block;
  flex-shrink: 0;
  width: 2px;
  height: 0.9em;
  margin-left: 1px;
  background: #5e5873;
  opacity: 1;
  animation: signupCursorBlink 0.6s steps(1) infinite;
}

.signup-typewriter:hover .signup-typewriter__text-idle,
.signup-typewriter:focus-visible .signup-typewriter__text-idle {
  max-width: 0;
  transition: max-width 0.35s steps(7, end);
}

.signup-typewriter:hover .signup-typewriter__text-done,
.signup-typewriter:focus-visible .signup-typewriter__text-done {
  max-width: 5em;
  transition: max-width 0.25s steps(7, end) 0.35s;
}

@keyframes signupCursorBlink {
  0%, 100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}
</style>
